const axios = require('axios');

module.exports.PuzzelClient = function () {
    var self = {};
    //constants
    var QUEUESTATUS = 'queueStatus';
    var TIMEEXIT = 'timeExit';

    var cache = {
        queueStatus: {
            results: [],
            config: {
                age: 1000, // milliseconds
            },
        },
        timeExit: {
            results: [],
            config: {
                age: 1000, // milliseconds
            },
        },
    };

    self.queueStatus = (customerKey, visualQueueId) => {
        if (!customerKey) {
            console.log('customerKey is required');
            // always resolve to make the implementation in ifhelp2015.js easier
            return new Promise((resolve, reject) => {
                resolve();
            });
        }

        if (!visualQueueId) {
            console.log('visualQueueId is required');
            // always resolve to make the implementation in ifhelp2015.js easier
            return new Promise((resolve, reject) => {
                resolve();
            });
        }

        // get cached promise
        var cachedPromise = undefined;
        for (var i = 0; i < cache.queueStatus.results.length; i++) {
            if (
                cache.queueStatus.results[i] &&
                cache.queueStatus.results[i].customerKey === customerKey &&
                cache.queueStatus.results[i].visualQueueId === visualQueueId
            ) {
                cachedPromise = cache.queueStatus.results[i];
                break;
            }
        }

        if (cachedPromise) {
            var promise = cachedPromise.promise;
            // not fulfilled
            if (promise.state == 0) return promise;

            // fulfilled
            return promise.then(function (res) {
                // the request failed, causing the result to be empty
                if (!res) {
                    cache.queueStatus.results = cache.queueStatus.results.filter(function (r) {
                        return (
                            r.customerKey !== cachedPromise.customerKey ||
                            r.visualQueueId !== cachedPromise.visualQueueId
                        );
                    });
                    return self.queueStatus(customerKey, visualQueueId);
                }

                // too old cache
                var cacheTime = new Date(res.timeOfResponse);
                var msDiff = Math.abs(new Date() - cacheTime);
                if (msDiff > cache.queueStatus.config.age) {
                    cache.queueStatus.results = cache.queueStatus.results.filter(function (r) {
                        return (
                            r.customerKey !== cachedPromise.customerKey ||
                            r.visualQueueId !== cachedPromise.visualQueueId
                        );
                    });
                    return self.queueStatus(customerKey, visualQueueId);
                }

                // valid cache
                return res;
            });
        }

        var requestPromise = new Promise((resolve, reject) => {
            axios({
                method: 'post',
                url: 'https://chat.puzzel.com/Queue/GetQueueStatusJson/',
                data: {
                    customerKey: customerKey,
                    visualQueueId: visualQueueId,
                },
                timeout: 3000,
            })
                .then((res) => {
                    const data = { ...res.data, timeOfResponse: new Date().getTime() };
                    resolve(data);
                })
                .catch((error) => {
                    console.log(error.response.data);

                    // always resolve to make the implementation in ifhelp2015.js easier
                    resolve();
                });
        });

        // cache the promise
        cache.queueStatus.results.push({
            promise: requestPromise,
            customerKey: customerKey,
            visualQueueId: visualQueueId,
        });

        return requestPromise;
    };

    self.timeExit = (customerKey, timeId) => {
        if (!customerKey) {
            console.log('customerKey is required');
            // always resolve to make the implementation in ifhelp2015.js easier
            return new Promise((resolve, reject) => {
                resolve();
            });
        }

        if (!timeId) {
            console.log('timeId is required');
            // always resolve to make the implementation in ifhelp2015.js easier
            return new Promise((resolve, reject) => {
                resolve();
            });
        }

        // get cached promise
        var cachedPromise = undefined;
        for (var i = 0; i < cache.timeExit.results.length; i++) {
            if (
                cache.timeExit.results[i] &&
                cache.timeExit.results[i].customerKey === customerKey &&
                cache.timeExit.results[i].timeId === timeId
            ) {
                cachedPromise = cache.timeExit.results[i];
                break;
            }
        }

        if (cachedPromise) {
            var promise = cachedPromise.promise;
            // not fulfilled
            if (promise.state == 0) return promise;

            // fulfilled
            return promise.then(function (res) {
                // the request failed, causing the result to be empty
                if (!res) {
                    cache.timeExit.results = cache.timeExit.results.filter(function (r) {
                        return (
                            r.customerKey !== cachedPromise.customerKey ||
                            r.timeId !== cachedPromise.timeId
                        );
                    });
                    return self.timeExit(customerKey, timeId);
                }

                // too old cache
                var cacheTime = new Date(res.timeOfResponse);
                var msDiff = Math.abs(new Date() - cacheTime);
                if (msDiff > cache.timeExit.config.age) {
                    cache.timeExit.results = cache.timeExit.results.filter(function (r) {
                        return (
                            r.customerKey !== cachedPromise.customerKey ||
                            r.timeId !== cachedPromise.timeId
                        );
                    });
                    return self.timeExit(customerKey, timeId);
                }

                // valid cache
                return res;
            });
        }

        var requestPromise = new Promise((resolve, reject) => {
            axios({
                method: 'post',
                url: 'https://chat.puzzel.com/Time/GetTimeExitJson/',
                data: {
                    customerKey: customerKey,
                    timeId: timeId,
                },
                timeout: 3000,
            })
                .then((res) => {
                    const data = { ...res.data, timeOfResponse: new Date().getTime() };
                    resolve(data);
                })
                .catch((error) => {
                    console.log('PuzzelClient: timeExit: ', error.response.data);

                    // always resolve to make the implementation in ifhelp2015.js easier
                    resolve();
                });
        });

        // cache the promise
        cache.timeExit.results.push({
            promise: requestPromise,
            customerKey: customerKey,
            timeId: timeId,
        });

        return requestPromise;
    };

    return self;
};
